@if (isFavoritesAvailable) {
<div class="list-favorite-star"
    (click)="toggleFavorite($event)">
    <span class="material-symbols-outlined"
        [ngClass]="{'material-symbols-filled': dataItem.Favorite}"
        style="vertical-align: middle;">star</span>
</div>
}